import React from 'react';
import { HashRouter, Routes, Route, Navigate } from 'react-router-dom';
import PublicPortal from './pages/PublicPortal';
import PropertyDetail from './pages/PropertyDetail';
import ExecutiveDashboard from './pages/ExecutiveDashboard';
import Login from './pages/Login';
import Header from './components/Header';
import { useAuth } from './hooks/useAuth';

function App() {
  const { user, loading } = useAuth();

  if (loading) return null;

  return (
    <HashRouter>
      <div className="min-h-screen bg-gray-50 flex flex-col font-sans">
        <Header />
        <main className="flex-grow">
          <Routes>
            {/* Rutas Públicas */}
            <Route path="/" element={<PublicPortal />} />
            <Route path="/propiedad/:id" element={<PropertyDetail />} />
            <Route path="/login" element={!user ? <Login /> : <Navigate to="/executive" />} />

            {/* Rutas Privadas (Ejecutivos) */}
            <Route 
              path="/executive" 
              element={user ? <ExecutiveDashboard /> : <Navigate to="/login" />} 
            />
          </Routes>
        </main>
        
        <footer className="bg-emerald-950 text-emerald-500 py-8 px-4 text-center text-sm border-t border-emerald-900">
          <p>© {new Date().getFullYear()} Arboleda Bienes Raíces Honduras. Todos los derechos reservados.</p>
        </footer>
      </div>
    </HashRouter>
  );
}

export default App;